export class PropertyTypeModel {
         public id: number;
         public slug: string;
         public name: string;

         constructor(obj: any) {
           this.id = obj.id ? obj.id : 0;
           this.slug = obj.slug ? obj.slug : "";
           this.name = obj.name ? obj.name : "";
         }
       }
